export const ALLOWED_MESSAGE_TYPES = [
  'LEASE',
  'FINANCE',
  'NEW_VEHICLE',
  'USED_VEHICLE',
  'CPO',
] as const;

export const FIELD_NAME_ENUM = [
  'voi_model',
  'New_Auto_Class',
  'CATCHALL',
] as const;

